var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96393_46028)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16791 15.1359L13.978 5.03595C14.4025 4.49129 14.5534 3.8616 14.4119 3.22044C14.2893 2.63756 13.9309 2.08335 13.3932 1.66292L12.0821 0.62139C10.9408 -0.286365 9.52588 -0.190812 8.71469 0.850717L7.83746 1.98876C7.72427 2.13113 7.75257 2.34135 7.89406 2.45601C7.89406 2.45601 10.1107 4.2333 10.1579 4.27152C10.3088 4.41485 10.422 4.60596 10.4503 4.83528C10.4974 5.28438 10.1862 5.70482 9.72397 5.76215C9.50702 5.79082 9.2995 5.72393 9.14858 5.59971L6.81875 3.74598C6.70556 3.66094 6.53578 3.67909 6.44145 3.79375L0.904567 10.9602C0.546132 11.4093 0.423509 11.9922 0.546132 12.556L1.25357 15.6232C1.2913 15.7857 1.43279 15.9003 1.60257 15.9003L4.7153 15.8621C5.28125 15.8526 5.80947 15.5946 6.16791 15.1359ZM10.5264 14.1808H15.6021C16.0973 14.1808 16.5001 14.5888 16.5001 15.0904C16.5001 15.593 16.0973 16.0001 15.6021 16.0001H10.5264C10.0312 16.0001 9.62847 15.593 9.62847 15.0904C9.62847 14.5888 10.0312 14.1808 10.5264 14.1808Z",
    fill: "#5B6673"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96393_46028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon2);
export default __webpack_public_path__ + "static/media/edit_icon_2.508c33ea649b7392c1058f98798c1da0.svg";
export { ForwardRef as ReactComponent };